import styled from 'styled-components';

export const CompareContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const NoAttrsMessage = styled.div`
  color: ${({ theme }) => theme.baseBlue.a6};
  text-align: center;
  padding-top: 20vh;

  a {
    color: ${({ theme }) => theme.baseBlue.a6};
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }
`;
